import { fetchApi } from "./fetchApi";

export default {
  create({ jiraType, releaseNoteId }) {
    return fetchApi({
      method: "post",
      url: `/api/releaseNote/${releaseNoteId}/jira/${jiraType}`,
    });
  },
};
